import axios from "axios";
import API_CONFIG from "../config/api";

const useApi = () => {
    const api = axios.create({
        baseURL: API_CONFIG.baseURL,
        withCredentials: true
    });

    api.interceptors.request.use(
        ( config ) => {
            console.log("Requisição para: ", config.url );
            return config;
        },
        ( error ) => {
            return Promise.reject( error );
        }
    )

    api.interceptors.response.use(
        ( response ) => response,
        ( error ) => {
            console.error("Erro na resposta: ", error.response ? error.response.data : error.message );
            return Promise.reject( error );
        }
    );

    return api;
}

export default useApi;